import { UserFlags } from '@/constants/common'

/**
 * Determines the maximum KYC flag based on the given flags.
 * @param flags - The user flags.
 * @returns The maximum KYC flag.
 */
export function maxKYC1Flag(flags: number): UserFlags {
  switch (true) {
    case (flags & UserFlags.KYC_1_REJECTED) > 0:
      return UserFlags.KYC_1_REJECTED
    case (flags & UserFlags.KYC_1_VERIFIED) > 0:
      return UserFlags.KYC_1_VERIFIED
    case (flags & UserFlags.KYC_1_SUBMITTED) > 0:
      return UserFlags.KYC_1_SUBMITTED
    default:
      return UserFlags.EMPTY
  }
}
